export default __webpack_public_path__ + "static/media/userLoc.d523705a.svg";